module.exports = new __parcel__URL__("buckley-classy.abfdadec.png").toString();